import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip, Popconfirm } from 'antd';
import { InputBaseModel } from '../../models';
import { InstanceUtils } from '../../misc';
import { useAppStore } from '../../stores';
import './ApplyToAllButton.less';

interface Props {
    input: InputBaseModel;
}

const ApplyToAllButton: React.FC<Props> = ({ input }) => {
    const { inputsStore } = useAppStore();

    const isEntryCodeInput = InstanceUtils.isEntryCodeNode(input.node);
    const hasMultipleEntryCodesInBalance =
        isEntryCodeInput &&
        InstanceUtils.isBalanceInformationNode(input.node.parentNode) &&
        input.node.parentNode.entryCodeNodes.length > 1;

    const isLockedOrReadOnly = input.isReadOnly === true || input.node.worksheet.isLocked === true;

    if (!input.hasValue || !hasMultipleEntryCodesInBalance || isLockedOrReadOnly) {
        return null;
    }

    const handleApplyToAll = () => {
        if (isLockedOrReadOnly) {
            return;
        }
        inputsStore.applyInputValueToAllEntryCodesInBalance(input);
    };

    return (
        <Popconfirm
            title="Apply this value to all entry codes in this balance?"
            onConfirm={handleApplyToAll}
            okText="Apply"
            cancelText="Cancel"
            placement="top"
        >
            <Tooltip title="Apply to all entry codes in this balance">
                <span className="apply-to-all-button">Apply to all</span>
            </Tooltip>
        </Popconfirm>
    );
};

export default observer(ApplyToAllButton);
